@if (permissionLabel) {
  <h4>{{permissionLabel}}</h4>
}
@if (allUsers?.length) {
    <div class="pb-2 mb-4 input-list-wrapper">
      <h6>{{usersLabel}}</h6>
      <div class="" (clickedOutside)="userFieldFocused = false" appClickedOutside>

        <input type="text" class="rounded-input-base full-width" placeholder="Search User" (focus)="userFieldFocused = true"
          (click)="userFieldFocused = true" [formControl]="userSearchControl" />

        @if (userFieldFocused) {
        <div class="zint-base-card zint-card-white border-rounded-05 mt-1 max-height-15vh min-width-fit position-relative z-10 scrollbar-show">
          @for (user of filteredUsers$ | async; track user.userId) {           
          <label class="form-label d-flex flex-wrap align-items-center list-menu" [ngClass]="$last ? 'mb-0': ''">
            <input type="checkbox" class="me-1" [checked]="selectedUserIds.has(user.userId)"
              (change)="onSelectionChange({userOrTeamObj: user, isChecked: $event.target.checked, group: 'user'})" />{{user.email}}
            @if (user.isOrganisationAdmin) {
            <small class="text-body-secondary ms-1">(Admin)</small>
            }
          </label>
          }
          @empty {
          <i class="fal fa-users-viewfinder fa-fade me-1"></i>
          <span>No users found</span>
          }
        </div>
        }
      </div>
      @if (selectedUsers?.length) {
      <div class="position-relative">
      <span class="list-counter">{{selectedUsers.length}}</span>
      </div>
      <div class="existing-list-wrapper" matTooltip="Existing users with permissions" matTooltipPosition="above">
        @for (user of selectedUsers; track user.userId) {
        <span class="badge-light-grey existing-list-item">{{user.email}}
          <small class="badge-close-button" (click)="removeSelectedUserOrTeam(user, 'user')"><i class="fas fa-times"></i></small>
        </span>
        }
      </div>
      }

    </div>
  } 

@if (allTeams?.length) {
  <div class="pb-2 mb-2 input-list-wrapper">
    <h6>{{teamsLabel}}</h6>
    <div (clickedOutside)="teamFieldFocused = false" appClickedOutside>
      <input type="text" class="rounded-input-base full-width" placeholder="Search Team" (focus)="teamFieldFocused = true"
        (click)="teamFieldFocused = true" [formControl]="teamSearchControl" />

      @if (teamFieldFocused) {
      <div class="zint-base-card zint-card-white border-rounded-05 mt-1 max-height-15vh min-width-fit position-relative z-10 scrollbar-show">
        @for (team of filteredTeams$ | async; track team.id) {
        <label class="form-label d-flex flex-wrap align-items-center" [ngClass]="$last ? 'mb-0': ''">
          <input type="checkbox" class="me-1" [checked]="selectedTeamIds.has(team.id)"
            (change)="onSelectionChange({userOrTeamObj: team, isChecked: $event.target.checked, group: 'team'})" />{{team.name}}
          @if (team.superuser_email) {
          <small class="text-body-secondary ms-1">({{ team.superuser_email }})</small> }
        </label>
        } @empty {
        <i class="fal fa-users-viewfinder fa-fade me-1"></i>
        <span>No teams found</span>
        }
      </div>
      }
    </div>

    @if (selectedTeams?.length) {
      <div class="position-relative">
        <span class="list-counter">{{selectedTeams.length}}</span>
      </div>
    <div class="existing-list-wrapper" matTooltip="Existing teams with permissions" matTooltipPosition="above">
      @for (team of selectedTeams; track team.id) {
      <span class="badge-light-grey existing-list-item">{{team.name}}
        <small class="badge-close-button" (click)="removeSelectedUserOrTeam(team, 'team')"><i class="fas fa-times"></i></small>
      </span>
      }
    </div>
    }
  </div>
}
